import Swiper from "swiper/bundle";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";

let swiperInstances = [];
let originalRowsContent = [];

function initializeMobileSwiper() {
  const mobileSwipers = document.querySelectorAll(".mobileSwiper");

  mobileSwipers.forEach((mobileSwiper, index) => {
    const scrollbarElement = mobileSwiper.querySelector(
      ".swiper-scrollbar-mobile"
    );
    const hasGrid3Style = mobileSwiper.querySelector(".is-style-grid-3");

    // Set the breakpoint condition based on the presence of .is-style-grid-3
    const breakpoint = hasGrid3Style ? 1750 : 1600;

    if (window.innerWidth <= breakpoint && !swiperInstances[index]) {
      if (!originalRowsContent[index]) {
        originalRowsContent[index] = mobileSwiper.innerHTML; // Save original content once
      }

      if (scrollbarElement) {
        scrollbarElement.style.display = "block";
      }

      swiperInstances[index] = new Swiper(mobileSwiper, {
        modules: [Scrollbar],
        speed: 700,
        direction: "horizontal",
        slidesPerGroup: 1,
        grabCursor: true,
        observer: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        scrollbar: {
          el: scrollbarElement,
          hide: false,
          draggable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: "auto",
            spaceBetween: 15,
          },
          765: {
            slidesPerView: "auto",
            spaceBetween: 15,
          },
        },
      });

      // Unwrap the content of any div with class 'row'
      const rows = mobileSwiper.querySelectorAll(".row");
      rows.forEach((row) => {
        while (row.firstChild) {
          row.parentNode.insertBefore(row.firstChild, row);
        }
        row.remove();
      });
    } else if (window.innerWidth > breakpoint && swiperInstances[index]) {
      swiperInstances[index].destroy(true, true);
      swiperInstances[index] = null;

      if (originalRowsContent[index]) {
        mobileSwiper.innerHTML = originalRowsContent[index]; // Restore original content
      }

      if (scrollbarElement) {
        scrollbarElement.style.display = "none";
      }
    }
  });
}

window.addEventListener("resize", initializeMobileSwiper);
window.addEventListener("load", initializeMobileSwiper);
